module.exports = __webpack_public_path__ + "static/img/2.021e1c87.png";